import React from 'react';

import { Typography } from '@material-ui/core';
import {
  CheckOutlined as CheckOutlinedIcon,
  ClearOutlined as ClearOutlinedIcon
} from '@material-ui/icons';
import { ButtonField, Step } from '../SteppedForm';

const StepOwneroperator = (props) => {
  return (
    <Step
      id="owneroperator"
      nonext
      title={props.getPersonalDetailsTitle('Owner/Operator')}
      skip={(formdata) => formdata.onboardingFor === 'vehicle'}>
      <Typography variant="body1" paragraph>
        As a {props.state.formdata.network} Operator will{' '}
        {props.state.formdata.orgtype === 'individual'
          ? 'you'
          : props.getApplicant().firstname + ' ' + props.getApplicant().surname}{' '}
        also be driving with {props.state.formdata.network}?
      </Typography>
      <br />
      <ButtonField
        id="owneroperator"
        value={true}
        label="Yes"
        className="TopIconButton"
        startIcon={<CheckOutlinedIcon />}
      />
      <ButtonField
        id="owneroperator"
        value={false}
        label="No"
        className="TopIconButton"
        startIcon={<ClearOutlinedIcon />}
      />
    </Step>
  );
};

export default StepOwneroperator;
